// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { i18n } from '../../index'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import ToiletCheckQuestionRow from './ToiletCheckQuestionRow'
import type { ToiletCheckQuestion } from './toiletCheckQuestionTypes'
import css from './toiletCheckQuestionTable.css'
import { alphaSort } from '../../../common/utils'
import { Paper } from '@mui/material'
type Props = {
  data: Array<ToiletCheckQuestion>
  onEdit: (...args: Array<any>) => any
}

class ToiletCheckQuestionTable extends React.PureComponent<Props> {
  render() {
    const { data, stationId, onEdit } = this.props
    return (
      <Paper>
        <div className={css.component}>
          {data.length ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={css.tableHeading}>
                    {i18n.t('admin.toiletCheckQuestions.label.description')}
                  </TableCell>
                  <TableCell className={css.tableHeading} />
                </TableRow>
              </TableHead>
              <TableBody>
                {alphaSort('description', data).map((toiletCheckQuestion, i) => (
                  <ToiletCheckQuestionRow data={toiletCheckQuestion} stationId={stationId} onEdit={onEdit} key={i} />
                ))}
              </TableBody>
            </Table>
          ) : (
            <p className={css.empty}>{i18n.t('admin.toiletCheckQuestions.noToiletCheckQuestions')}</p>
          )}
        </div>
      </Paper>
    )
  }
}

export default ToiletCheckQuestionTable
